import * as React from "react";
import { ChangeQtyButton } from "../../styles";

export const MinusIcon = ({ onClick, disabled = false }) => (
  <ChangeQtyButton onClick={onClick} disabled={disabled}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#068EC3"
        stroke="#068EC3"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16 12H8"
      ></path>
    </svg>
  </ChangeQtyButton>
);

export const PlusIcon = ({ onClick, disabled = false }) => (
  <ChangeQtyButton onClick={onClick} disabled={disabled}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 23 24"
    >
      <path
        fill="#068EC3"
        stroke="#068EC3"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11.5 2C6.207 2 1.917 6.477 1.917 12s4.29 10 9.583 10 9.584-4.477 9.584-10S16.793 2 11.5 2Z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11.5 16V8M15.334 12H7.667"
      ></path>
    </svg>
  </ChangeQtyButton>
);

export const AttentionIcon = ({ color = "#068EC3", size = 64 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 64 64"
  >
    <path
      stroke={color}
      strokeLinejoin="round"
      strokeWidth="4"
      d="M32 58.667c7.364 0 14.03-2.985 18.856-7.81A26.58 26.58 0 0 0 58.666 32c0-7.364-2.984-14.03-7.81-18.856A26.58 26.58 0 0 0 32 5.334a26.58 26.58 0 0 0-18.856 7.81A26.58 26.58 0 0 0 5.334 32c0 7.364 2.984 14.03 7.81 18.856A26.58 26.58 0 0 0 32 58.666Z"
    ></path>
    <path
      fill={color}
      fillRule="evenodd"
      d="M32 49.333a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666"
      clipRule="evenodd"
    ></path>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M32 16v21.333"
    ></path>
  </svg>
);

export const BallotIcon = ({ color = "#62748E" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="24"
    fill="none"
    viewBox="0 0 35 24"
    className="stroke"
  >
    <path
      stroke={color}
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M2.917 3.75h29.167v18H2.917z"
    ></path>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M2.917 9.75c3.222 0 5.833-2.686 5.833-6H2.917zM2.917 15.75c3.222 0 5.833 2.686 5.833 6H2.917zM32.083 15.75v6H26.25c0-3.314 2.612-6 5.833-6M32.083 9.75c-3.221 0-5.833-2.686-5.833-6h5.833z"
      clipRule="evenodd"
    ></path>
    <path
      stroke={color}
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M17.5 17.25c2.014 0 3.646-2.015 3.646-4.5s-1.632-4.5-3.646-4.5c-2.013 0-3.645 2.015-3.645 4.5s1.632 4.5 3.645 4.5Z"
    ></path>
  </svg>
);

export const QRCode = ({ color = "#62748E" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="fill"
  >
    <g clip-path="url(#clip0_2607_4094)">
      <path
        d="M0 8L8 8L8 0L0 0L0 8ZM1.33333 1.33333L6.66667 1.33333L6.66667 6.66667L1.33333 6.66667L1.33333 1.33333ZM2.66667 2.66667L5.33333 2.66667L5.33333 5.33333L2.66667 5.33333L2.66667 2.66667ZM16 8L24 8V0L16 0L16 8ZM17.3333 1.33333L22.6667 1.33333V6.66667L17.3333 6.66667V1.33333ZM18.6667 2.66667L21.3333 2.66667V5.33333L18.6667 5.33333V2.66667ZM0 24H8L8 16H0L0 24ZM1.33333 17.3333H6.66667L6.66667 22.6667H1.33333L1.33333 17.3333ZM2.66667 18.6667H5.33333L5.33333 21.3333H2.66667L2.66667 18.6667ZM22.6667 21.3333H24V24H21.3333V20H22.6667V21.3333ZM22.6667 17.3333H24V18.6667H22.6667V17.3333ZM22.6667 16V17.3333H21.3333V16H22.6667ZM9.33333 18.6667H10.6667V24H9.33333V18.6667ZM4 9.33333L4 12H1.33333L1.33333 10.6667H0L0 9.33333H4ZM9.33333 5.33333H10.6667L10.6667 6.66667H9.33333L9.33333 5.33333ZM13.3333 1.33333V4H12V0L14.6667 0V1.33333L13.3333 1.33333ZM9.33333 1.33333L10.6667 1.33333V2.66667L9.33333 2.66667V1.33333ZM22.6667 12H24V14.6667H21.3333V13.3333H22.6667V12ZM21.3333 9.33333V10.6667H18.6667L18.6667 13.3333L16 13.3333V12L17.3333 12L17.3333 9.33333H21.3333ZM12 14.6667H10.6667V13.3333H9.33333V12H12V14.6667ZM20 17.3333H21.3333V18.6667H20V17.3333ZM22.6667 10.6667L22.6667 12H21.3333L21.3333 10.6667H22.6667ZM10.6667 14.6667V16H9.33333V14.6667H10.6667ZM18.6667 21.3333H20V24H17.3333V21.3333H18.6667ZM14.6667 21.3333H16V22.6667H14.6667V24H12V22.6667H13.3333V21.3333H14.6667ZM14.6667 20V18.6667H17.3333V20H14.6667ZM14.6667 13.3333H16L16 17.3333H14.6667V18.6667H13.3333V20H12V17.3333L10.6667 17.3333L10.6667 16L14.6667 16V14.6667H13.3333V13.3333H14.6667ZM2.66667 13.3333V14.6667H1.33333L1.33333 13.3333H2.66667ZM18.6667 18.6667H17.3333V17.3333H18.6667V18.6667ZM20 16H17.3333V14.6667H20V16ZM6.66667 9.33333H8V10.6667H6.66667V12H8L8 14.6667H6.66667L6.66667 13.3333L5.33333 13.3333L5.33333 14.6667H4L4 12H5.33333V9.33333L6.66667 9.33333ZM10.6667 9.33333V6.66667L14.6667 6.66667V10.6667H12V9.33333H13.3333V8H12V9.33333H10.6667ZM10.6667 4H12V5.33333H10.6667V4ZM9.33333 9.33333H10.6667V10.6667H9.33333V9.33333ZM13.3333 5.33333V4L14.6667 4V5.33333L13.3333 5.33333Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_2607_4094">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CardIcon = ({ color = "#62748E" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className="stroke"
  >
    <path
      stroke={color}
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M2 4.125C2 3.504 2.448 3 3 3h18c.552 0 1 .504 1 1.125v15.75c0 .621-.448 1.125-1 1.125H3c-.552 0-1-.504-1-1.125z"
    ></path>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M2 9h20M13.5 16.5H18M22 4.5v12M2 4.5v12"
    ></path>
  </svg>
);

export const CouponIcon = ({ size = 16, color = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
    stroke={color}
    strokeWidth="0"
    viewBox="0 0 24 24"
  >
    <path fill="none" stroke="none" d="M0 0h24v24H0z"></path>
    <path
      stroke="none"
      d="M12.79 21 3 11.21v2c0 .53.21 1.04.59 1.41l7.79 7.79c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83z"
    ></path>
    <path
      stroke="none"
      d="M11.38 17.41c.39.39.9.59 1.41.59s1.02-.2 1.41-.59l6.21-6.21c.78-.78.78-2.05 0-2.83L12.62.58C12.25.21 11.74 0 11.21 0H5C3.9 0 3 .9 3 2v6.21c0 .53.21 1.04.59 1.41zM5 2h6.21L19 9.79 12.79 16 5 8.21z"
    ></path>
    <circle cx="7.25" cy="4.25" r="1.25" stroke="none"></circle>
  </svg>
);

export const CancelIcon = ({ size = 20, color = "#314158" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
    stroke={color}
    strokeWidth="0"
    viewBox="0 0 24 24"
  >
    <path fill="none" stroke="none" d="M0 0h24v24H0z" opacity="0.87"></path>
    <path
      stroke="none"
      d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z"
    ></path>
  </svg>
);

export const CheckmarkIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="78"
    height="79"
    fill="none"
    viewBox="0 0 78 79"
  >
    <path
      fill="#068EC3"
      d="M39 .75C17.649.75.25 18.15.25 39.5.25 60.852 17.649 78.25 39 78.25S77.75 60.852 77.75 39.5C77.75 18.15 60.351.75 39 .75m18.523 29.838L35.55 52.559a2.903 2.903 0 0 1-4.107 0L20.478 41.593a2.924 2.924 0 0 1 0-4.108 2.924 2.924 0 0 1 4.107 0l8.913 8.913L53.415 26.48a2.924 2.924 0 0 1 4.108 0c1.123 1.124 1.123 2.945 0 4.108"
    ></path>
  </svg>
);

export const PrinterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_833_10496)">
      <path
        d="M12.3337 10.6665H3.66699V14.6665H12.3337V10.6665Z"
        stroke="#002244"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.33301 6.6665H14.6663V12.6665H12.3388V10.6665H3.65984V12.6665H1.33301V6.6665Z"
        stroke="#002244"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6663 1.3335H3.33301V6.66683H12.6663V1.3335Z"
        stroke="#002244"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_833_10496">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
